const steps = [
  { num: '1', title: 'Выявить причину сопротивления', desc: 'Что именно человеку не подходит: сам процесс, его последствия или страх перед неизвестностью?' },
  { num: '2', title: 'Отделить факты от эмоций', desc: 'Есть ли реальная проблема в новом решении или это опасение, которое можно снять объяснением?' },
  { num: '3', title: 'Объяснить необходимость изменений', desc: 'Почему компания меняется и какую проблему решает — на понятном сотруднику языке.' },
  { num: '4', title: 'Дать возможность задать вопросы', desc: 'Не оставлять сотрудников один на один с неопределённостью и домыслами.' },
  { num: '5', title: 'Обучить', desc: 'Дать необходимые знания и навыки, без которых новый способ работы невозможен.' },
  { num: '6', title: 'Дать практику', desc: 'Позволить безопасно попробовать новый способ работы без страха за ошибку.' },
  { num: '7', title: 'Получить обратную связь', desc: 'Что работает? Где возникают сложности? Что нужно донастроить?' },
  { num: '8', title: 'Закрепить', desc: 'Встроить новое поведение в процессы, стандарты и контроль, чтобы оно стало нормой.' },
];

export default function WorkingWithResistance() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как работать с сопротивлением
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Сопротивление — это сигнал. Практический алгоритм, который помогает не давить, а управлять переходом
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-5">
            {steps.map((step) => (
              <div key={step.num} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-lg font-bold flex-shrink-0 z-10">
                  {step.num}
                </div>
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{step.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}